import React, { useState } from "react"
import { Col, Collapse, Row } from "reactstrap"
import classnames from "classnames"
import MultipleView from "./MultipleView"

const ViewInput = ({
  item,
  sethandleAccordion,
  handleAccordion,
  keyId,
  HoursReportPage,
  username,
  selectedprojectId,
  activeReportStatus,
}) => {
  const handleOnclickAccordion = value => {
    if (handleAccordion === value) {
      sethandleAccordion(null)
    } else {
      sethandleAccordion(value)
    }
  }
  const [Multipleaccordian, setmultipleaccordian] = useState(false)

  const Name = item?.map(el =>
    selectedprojectId?.id == undefined ? el.displayName : el.displayName
  )
  const userName = item?.map(el => el.userName)
  return (
    <>
      {!HoursReportPage ? (
        <div className="accordion p-2" id={`accordion-${keyId}`}>
          <div className="accordion-item mb-2">
            <h2 className="accordion-header" id={`heading-${keyId}`}>
              <button
                className={classnames("accordion-button", "fw-medium", {
                  collapsed: handleAccordion !== keyId,
                })}
                type="button"
                onClick={() => handleOnclickAccordion(keyId)}
                style={{ cursor: "pointer" }}
              >
                <div className="d-flex d-flex-justspace mobile_accordian">
                  {activeReportStatus?.id !== 2 ? (
                    <div>
                      {HoursReportPage
                        ? " Date:"
                        : username
                        ? "Name:"
                        : "Project:"}{" "}
                      <span className="addposition">
                        {HoursReportPage
                          ? item?.timeSummaryDate
                          : username
                          ? userName[0]
                          : Name?.[0]}
                      </span>
                    </div>
                  ) : (
                    <div>{item?.[0]?.userName}</div>
                  )}
                </div>
              </button>
            </h2>

            <Collapse isOpen={handleAccordion === keyId}>
              <div className="accordion-body">
                <div className="text-muted">
                  <Row>
                    <Col md="12">
                      {!HoursReportPage && (
                        <>
                          {item?.map((data, index) => (
                            <div key={index}>
                              <MultipleView
                                item={data}
                                keyId={index}
                                sethandleAccordion={setmultipleaccordian}
                                handleAccordion={Multipleaccordian}
                                activeReportStatus={activeReportStatus}
                              />
                            </div>
                          ))}
                        </>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      ) : (
        <div>
          {item?.map((el, index) => (
            <div key={index}>
              <div className="pb-2">
                <strong>Project: </strong>
                {el.displayName}
              </div>
              <div
                className="input-static-widthteams pre-wrap"
                style={{
                  background: "#fff",
                  marginBottom: "1.5rem",
                  minHeight: "90px",
                  borderBottomWidth: "2px",
                }}
                dangerouslySetInnerHTML={{
                  __html: el.reportDetail,
                }}
              />
            </div>
          ))}
        </div>
      )}
    </>
  )
}

export default ViewInput
